"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var _react = _interopRequireWildcard(require("react"));
var RadixCheckbox = _interopRequireWildcard(require("@radix-ui/react-checkbox"));
var _Icons = require("../Icons");
var _Image = require("../Image");
var _CheckboxModule = _interopRequireDefault(require("./Checkbox.module.css"));
var _excluded = ["className", "name", "isDisabled", "checked", "variant", "onChange"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Temporarily marked as experimental
 * @experimental
 */
var Checkbox = _ref => {
  var className = _ref.className,
    name = _ref.name,
    isDisabled = _ref.isDisabled,
    checked = _ref.checked,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'standard' : _ref$variant,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var bodyProps;
  var commonProps = {
    isDisabled,
    name
  };
  if (variant === 'standard') {
    bodyProps = _objectSpread(_objectSpread({}, rest), commonProps);
  } else {
    bodyProps = _objectSpread(_objectSpread({}, rest), commonProps);
  }
  var _useState = (0, _react.useState)(checked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var handleChange = checkState => {
    if (!isDisabled) {
      setIsChecked(checkState);
      onChange(checkState);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _CheckboxModule.default.Checkbox,
    "data-disabled": isDisabled,
    "data-variant": variant,
    "data-checked": isChecked
  }, /*#__PURE__*/_react.default.createElement(RadixCheckbox.Root, {
    className: _CheckboxModule.default.CheckboxRoot,
    checked: isChecked,
    disabled: isDisabled,
    onCheckedChange: handleChange,
    id: name
  }, /*#__PURE__*/_react.default.createElement(RadixCheckbox.Indicator, {
    className: _CheckboxModule.default.CheckboxIndicator
  }, /*#__PURE__*/_react.default.createElement(_Icons.IconCheck, {
    size: '0.9rem'
  }))), variant === 'standard' ? /*#__PURE__*/_react.default.createElement(StandardBody, bodyProps) : /*#__PURE__*/_react.default.createElement(AdvancedBody, bodyProps));
};

/*******************
 * Advanced Title and Description
 *******************/
exports.Checkbox = Checkbox;
var AdvancedBody = props => {
  var name = props.name,
    title = props.title,
    description = props.description,
    image = props.image;
  return /*#__PURE__*/_react.default.createElement("label", {
    className: _CheckboxModule.default.Label,
    htmlFor: name
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-has-image": image && true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CheckboxModule.default.Title
  }, " ", title), /*#__PURE__*/_react.default.createElement("div", {
    className: _CheckboxModule.default.Description
  }, " ", description)), image && /*#__PURE__*/_react.default.createElement("div", {
    className: _CheckboxModule.default.CheckboxImageContainer
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    src: image,
    alt: title + '_info',
    className: _CheckboxModule.default.CheckboxImage
  })));
};

/*******************
 * Standard Label
 *******************/
var StandardBody = props => {
  var text = props.text,
    name = props.name,
    isDisabled = props.isDisabled,
    link = props.link;
  return /*#__PURE__*/_react.default.createElement("label", {
    className: _CheckboxModule.default.Label,
    "data-link": link && true,
    "data-no-text-or-link": !link && !text && true,
    htmlFor: name
  }, text && /*#__PURE__*/_react.default.createElement("div", {
    "data-label-link": text && link && true
  }, text), link && /*#__PURE__*/_react.default.createElement(LinkComponent, {
    link: link,
    isDisabled: isDisabled
  }));
};

/*******************
 * Link
 *******************/

var LinkComponent = _ref2 => {
  var link = _ref2.link,
    isDisabled = _ref2.isDisabled;
  if (link.onClickLink) {
    var _ref3 = link,
      _text = _ref3.text,
      onClickLink = _ref3.onClickLink;
    var handleClick = event => {
      if (!isDisabled) {
        event.preventDefault();
        onClickLink();
      }
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: handleClick,
      className: _CheckboxModule.default.Link
    }, _text);
  }
  var _ref4 = link,
    text = _ref4.text,
    href = _ref4.href,
    _ref4$openInNewTab = _ref4.openInNewTab,
    openInNewTab = _ref4$openInNewTab === void 0 ? true : _ref4$openInNewTab;
  return /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    target: openInNewTab ? '_blank' : '_self',
    className: _CheckboxModule.default.Link,
    rel: "noreferrer"
  }, text);
};
//# sourceMappingURL=Checkbox.js.map